import {
  combine,
  createStore,
  createEvent,
  createEffect,
  sample,
} from 'effector';
import { createTableModel } from './tableModel';
import { actions as accountActions } from 'src/effector/fleet/createAccount';
import some from 'lodash/some';

const setData = createEvent();
const initPaypair = createEvent();
const onPaypairEventPreApproved = createEvent();

const $visits = createStore([]).on(setData, (_, data) => data.visits);
const $searchResults = createStore([]).on(
  setData,
  (_, data) => data.search_results,
);
const $deals = createStore([]).on(setData, (_, data) => data.deals);
const $user = createStore({}).on(setData, (_, data) => data.user);

const visitsTable = createTableModel($visits);
const searchResultsTable = createTableModel($searchResults);
const dealsTable = createTableModel($deals, 'id', 3);

sample({
  clock: setData,
  fn: data => console.log('dashboardData', data),
});

const initPaypairFx = createEffect().use(({ info }) => {
  console.log('businessInfo', info);
  const businessInfo = {
    name: info.companyName || `${info.firstName} ${info.lastName}`,
    dba: info.dba || '',
    street_1: info.streetAddress,
    street_2: info.streetAddress2 || '',
    city: info.city,
    state: info.state_abbr,
    zip: info.zipcode,
    total_annual_revenue:
      Number(info.totalAnnualRevenue) || Number(info.grossMonthlyIncome) * 12,
    type: info.entityType || 'Sole Proprietorship',
    phone: info.phone,
    ein: info.ein,
    industry: info.industry || info.profession,
  };
  console.log('businessInfo', businessInfo);
  const options = {
    orderDetails: {
      prequalification: true,
      b2b: true,
      businessInfo,
    },
  };

  console.log('Paypair.open ', options);
  window.addEventListener('message', event => {
    if (event.data.type === 'maxAmount') {
      console.log('onPaypairEventPreApproved:', event.data);
      onPaypairEventPreApproved(event.data.amount);
    }
  });

  window.Paypair.open(options);
});

sample({
  source: $user.map(user => user.additional_info),
  clock: initPaypair,
  fn: additional_info => ({ info: additional_info }),
  target: initPaypairFx,
});

sample({
  source: $user,
  clock: onPaypairEventPreApproved,
  fn: (user, amount) => ({
    user: {
      additional_info: {
        ...user.additional_info,
        preApprovedAmount: amount,
      },
      email: user.email,
    },
  }),
  target: accountActions.addPreApprovedAmountFx,
});

sample({
  clock: accountActions.addPreApprovedAmountFx.done,
  fn: data => {
    return data.result.user;
  },
  target: $user,
});

const $preApprovedAmount = $user.map(
  user => user?.additional_info?.preApprovedAmount,
);

const $isProprietor = $user.map(user =>
  some(user.spree_roles, { name: 'proprietor' }),
);

const $isBusiness = $user.map(user =>
  some(user.spree_roles, { name: 'business' }),
);

export const stores = {
  $visitsPagedItems: visitsTable.store.$pagedItems,
  $visitsCurrentPage: visitsTable.store.$currentPage,
  $visitsTotalPages: visitsTable.store.$totalPages,
  $visitsIsShownPrevBtn: visitsTable.store.$isShownPrevBtn,
  $visitsIsShownNextBtn: visitsTable.store.$isShownNextBtn,
  $visitsIsShownPagination: visitsTable.store.$isShownPagination,
  $visitsSortField: visitsTable.store.$sortField,
  $visitsSortDirection: visitsTable.store.$sortDirection,

  $searchResultsPagedItems: searchResultsTable.store.$pagedItems,
  $searchResultsCurrentPage: searchResultsTable.store.$currentPage,
  $searchResultsTotalPages: searchResultsTable.store.$totalPages,
  $searchResultsIsShownPrevBtn: searchResultsTable.store.$isShownPrevBtn,
  $searchResultsIsShownNextBtn: searchResultsTable.store.$isShownNextBtn,
  $searchResultsIsShownPagination: searchResultsTable.store.$isShownPagination,
  $searchResultsSortField: searchResultsTable.store.$sortField,
  $searchResultsSortDirection: searchResultsTable.store.$sortDirection,

  $dealsPagedItems: dealsTable.store.$pagedItems,
  $dealsCurrentPage: dealsTable.store.$currentPage,
  $dealsTotalPages: dealsTable.store.$totalPages,
  $dealsIsShownPrevBtn: dealsTable.store.$isShownPrevBtn,
  $dealsIsShownNextBtn: dealsTable.store.$isShownNextBtn,
  $dealsIsShownPagination: dealsTable.store.$isShownPagination,

  $searchResults,
  $visits,
  $deals,
  $user,
  $preApprovedAmount,
  $isProprietor,
  $isBusiness,
};

export const actions = {
  setData,
  initPaypair,
  visits: visitsTable.actions,
  searchResults: searchResultsTable.actions,
  deals: dealsTable.actions,
};

export const store = combine(stores);
